import { useEffect, useState, memo } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { extractInitials } from "../utils/GenericFunction";

function Avtar({ photoUrl, userName, people }) {
  const { hostCommunicationUserId, photoHostUrl, attendeesLookup } = useLiveStreamAppContext();
  const [photo, setPhoto] = useState("");

  useEffect(() => {
    if (people) {
      const decodedCommunicationUserId = decodeURIComponent(
        people?.identifier?.communicationUserId
      );
      let matchingAttendee = attendeesLookup[decodedCommunicationUserId];
      if (matchingAttendee) {
        setPhoto(matchingAttendee.photo);
      } else {
        const decodedCommunicationUserId2 = people?.communicationUserId;
        matchingAttendee = attendeesLookup[decodedCommunicationUserId2];
        if (matchingAttendee) {
          setPhoto(matchingAttendee.photo);
        } else if (hostCommunicationUserId === decodedCommunicationUserId2) {
          setPhoto(photoHostUrl);
        }
      }
      if (hostCommunicationUserId === decodedCommunicationUserId) {
        setPhoto(photoHostUrl);
      }
    }
  }, [people]);

  return (
    <>
      <div className="avatar-size">
        <div
          className="avatar lazylivestreamimg"
          style={{
            backgroundImage: `url(${photoUrl?.length > 0 ? photoUrl : photo})`,
          }}
        >
          {photoUrl?.length > 0 || photo?.length > 0 ? (
            ""
          ) : (
            <div className="initialspusername">{extractInitials(userName)}</div>
          )}
        </div>
      </div>
    </>
  );
}

export default memo(Avtar);
